import {Injectable} from '@angular/core';

import 'rxjs/add/operator/toPromise';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import {ApiService} from './api.service';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/do';
import {Contract} from '../model/Entities/Contract';
import {ContractItem} from '../model/Entities/ContractItem';
import {ContractItemTransfer} from '../model/Entities/ContractItemTransfer';

@Injectable()
export class ContractItemTransferService extends ApiService<ContractItemTransfer> {

    protected apiUrl = 'api/contract-item-transfers';  // URL to web api

    protected getObjectType(): any {
        return ContractItemTransfer;
    }
}



// WEBPACK FOOTER //
// /app/src/services/contract-item-transfer.service.ts